<template lang="pug">
#modal-editar-cadastrar-representante
    el-dialog(
        width='600px',
        :title='`${editar ? $t("mensagens.comuns.editar") : $t("mensagens.comuns.cadastrar")} ${$t("mensagens.pessoas.pessoa")}`',
        :visible.sync='mostrar',
        :close-on-click-modal='false',
        :before-close='fechar'
    )
        el-form(:model='formulario', ref='formulario', label-position='top')
            el-form-item(
                v-for='(item, index) in formulario.form',
                :label='$t(item.label)',
                :key='item.key',
                :prop='"form." + index + ".value"',
                :rules='item.rules',
                style='width: 100%'
            )
                component(
                    v-if='!item.bind.mask',
                    :is='item.component',
                    v-model='item.value',
                    v-bind='item.bind',
                    style='width: 100%',
                    :placeholder='$t(item.bind.placeholder)',
                    @change='updateCity(item.key)'
                )
                    el-option(
                        v-for='tipo in item.options',
                        :key='tipo.code',
                        :label='tipo.label',
                        :value='tipo.code'
                    )
                component(
                    v-else,
                    :is='item.component',
                    v-model='item.value',
                    v-bind='item.bind',
                    v-mask='inputMask[item.key]',
                    :placeholder='$t(item.bind.placeholder)',
                    @change='updateCity(item.key)',
                    @input='updateMask(item.key, item.bind.mask, item.value)'
                )
                    el-option(
                        v-for='tipo in item.options',
                        :key='tipo.code',
                        :label='tipo.label',
                        :value='tipo.code'
                    )
        footer.espaco(slot='footer')
            el-button(type='default', @click='fechar')
                | {{
                | $t("mensagens.comuns.cancelar")
                | }}
            el-button(type='primary', @click='salvar("formulario")')
                | {{
                | $t("mensagens.comuns.salvar")
                | }}
    modal-atalho-territorio(
        :mostrar='mostrarModalRedirecionamentoTerritorio',
        @fechar='fecharModalAtalhoTerritorio'
    )
</template>

<script>
import RepresentanteService from '@/services/RepresentanteService';
import LocalidadeService from '@/services/LocalidadeService';

import formatters from '@/utils/formatters';
import validators from '@/utils/validators';
import { ParaguayRUCValidator } from '@/utils/validations/ruc';
import { validateCuit } from '@/utils/validations/cuit';
import ModalAtalhoTerritorio from '@/components/ModalAtalhoTerritorio';
import { mapActions, mapGetters } from 'vuex';

import { AmbientesEmpresas } from '@/constants/AmbienteLogado.js';

export default {
    name: 'ModalEditarCadastrarRepresentante',
    components: {
        ModalAtalhoTerritorio
    },

    props: {
        mostrar: {
            type: Boolean,
            required: true
        },

        editar: {
            type: Boolean,
            required: false,
            default: false
        },

        dadosRepresentante: {
            type: Object,
            required: false,
            default: null
        }
    },

    data() {
        const validationDocument = (_, value, callback) => {
            if (this.locale === 'py') {
                const validator = new ParaguayRUCValidator();
                if (!validator.validateRUC(value)) {
                    callback(this.$t('mensagens.pessoas.numeroRucErro'));
                } else {
                    callback();
                }
            } else if (this.locale === 'ar') {
                if (!validateCuit(value)) {
                    callback(this.$t('mensagens.pessoas.cuitErro'));
                } else {
                    callback();
                }
            } else {
                if (!validators.validarCpfCnpj(value)) {
                    callback(this.$t('mensagens.pessoas.numeroCpfCnpjErro'));
                } else {
                    callback();
                }
            }
        };

        const validationName = (_, value, callback) => {
            if (value.trim().length < 3) {
                callback(
                    this.$t('mensagens.pessoas.digiteTresCaracteresParaSalvar')
                );
            } else {
                callback();
            }
        };

        return {
            inputMask: {
                documento: '#################',
                telefone: '###########'
            },
            mostrarModalRedirecionamentoTerritorio: false,
            ambientes: AmbientesEmpresas,
            paises: [
                { id: 1, code: 'BR', label: 'Brasil' },
                { id: 2, code: 'PY', label: 'Paraguai' },
                { id: 3, code: 'AR', label: 'Argentina' }
            ],
            form: {
                base: [
                    {
                        key: 'pais',
                        label: 'mensagens.comuns.pais',
                        component: 'el-input',
                        value: '',
                        rules: {
                            required: true,
                            message: this.$t(
                                'mensagens.comuns.campoObrigatorio'
                            ),
                            trigger: 'blur'
                        },
                        bind: {
                            class: 'w-full',
                            disabled: true,
                            valueKey: 'label'
                        }
                    },
                    {
                        key: 'nome',
                        label: 'mensagens.pessoas.nomeRazaoSocial',
                        component: 'el-input',
                        value: '',
                        rules: [
                            {
                                required: true,
                                message: this.$t(
                                    'mensagens.comuns.campoObrigatorio'
                                ),
                                trigger: 'blur'
                            },
                            {
                                validator: validationName,
                                thigger: 'blur'
                            }
                        ],
                        bind: {
                            placeholder: 'mensagens.pessoas.nomeRazaoSocial'
                        }
                    },
                    {
                        key: 'documento',
                        label: 'mensagens.pessoas.documento',
                        component: 'el-input',
                        value: '',
                        rules: [
                            {
                                required: true,
                                message: this.$t(
                                    'mensagens.comuns.campoObrigatorio'
                                ),
                                trigger: 'blur'
                            },
                            {
                                validator: validationDocument,
                                thigger: 'blur'
                            }
                        ],
                        bind: {
                            placeholder: 'mensagens.pessoas.numeroCpfCnpj',
                            mask: true
                        }
                    },
                    {
                        label: 'mensagens.comuns.email',
                        component: 'el-input',
                        value: '',
                        rules: [
                            {
                                type: 'email',
                                message: this.$t(
                                    'mensagens.pessoas.emailInvalido'
                                ),
                                trigger: ['blur', 'change']
                            },
                            {
                                // validator: validationEmail,
                                required: true,
                                message: this.$t(
                                    'mensagens.comuns.campoObrigatorio'
                                ),
                                trigger: ['blur', 'change']
                            }
                        ],
                        bind: {
                            placeholder: 'mensagens.comuns.email'
                        }
                    }
                ],
                br: [
                    {
                        key: 'id',
                        label: this.isAlvorada
                            ? 'BP Pessoa'
                            : 'mensagens.operacao.formularioPessoa.idPessoa',
                        component: 'el-input',
                        value: '',
                        bind: {
                            maxlength: 200,
                            placeholder: this.isAlvorada
                                ? 'BP Pessoa'
                                : 'mensagens.operacao.formularioPessoa.idPessoa'
                        }
                    }
                ],
                py: [
                    {
                        key: 'telefone',
                        label: 'mensagens.pessoas.telefone',
                        component: 'el-input',
                        value: '',
                        bind: {
                            placeholder: 'mensagens.comuns.telefone',
                            mask: true
                        }
                    },
                    {
                        key: 'endereco',
                        label: 'mensagens.pessoas.endereco',
                        component: 'el-input',
                        value: '',
                        bind: {
                            placeholder: 'mensagens.pessoas.endereco'
                        }
                    },
                    {
                        key: 'estado',
                        label: 'mensagens.pessoas.departamento',
                        component: 'el-select',
                        value: '',
                        options: [],
                        rules: {
                            required: true,
                            message: this.$t(
                                'mensagens.comuns.campoObrigatorio'
                            ),
                            trigger: 'blur'
                        },
                        bind: {
                            placeholder: 'mensagens.pessoas.departamento',
                            valueKey: 'label'
                        }
                    },
                    {
                        key: 'municipio',
                        label: 'mensagens.pessoas.distrito',
                        component: 'el-select',
                        value: '',
                        options: [],
                        rules: {
                            required: true,
                            message: this.$t(
                                'mensagens.comuns.campoObrigatorio'
                            ),
                            trigger: 'blur'
                        },
                        bind: {
                            placeholder: 'mensagens.pessoas.distrito',
                            valueKey: 'label'
                        }
                    },
                    {
                        key: 'id',
                        label: this.isAlvorada
                            ? 'BP Pessoa'
                            : 'mensagens.operacao.formularioPessoa.idPessoa',
                        component: 'el-input',
                        value: '',
                        bind: {
                            maxlength: 200,
                            placeholder: this.isAlvorada
                                ? 'BP Pessoa'
                                : 'mensagens.operacao.formularioPessoa.idPessoa'
                        }
                    }
                ],
                ar: [
                    {
                        key: 'telefone',
                        label: 'mensagens.pessoas.telefone',
                        component: 'el-input',
                        value: '',
                        bind: {
                            placeholder: 'mensagens.comuns.telefone',
                            mask: true
                        }
                    },

                    // {
                    //     key: 'endereco',
                    //     label: 'mensagens.pessoas.endereco',
                    //     component: 'el-input',
                    //     value: '',
                    //     bind: {
                    //         placeholder: 'mensagens.pessoas.endereco'
                    //     }
                    // },
                    {
                        key: 'estado',
                        label: 'mensagens.pessoas.estadoAr',
                        component: 'el-select',
                        value: '',
                        options: [],
                        rules: {
                            required: true,
                            message: this.$t(
                                'mensagens.comuns.campoObrigatorio'
                            ),
                            trigger: 'blur'
                        },
                        bind: {
                            placeholder: 'mensagens.pessoas.estadoAr',
                            valueKey: 'code'
                        }
                    },
                    {
                        key: 'municipio',
                        label: 'mensagens.pessoas.municipioAr',
                        component: 'el-select',
                        value: '',
                        options: [],
                        rules: {
                            required: true,
                            message: this.$t(
                                'mensagens.comuns.campoObrigatorio'
                            ),
                            trigger: 'blur'
                        },
                        bind: {
                            placeholder: 'mensagens.pessoas.municipioAr',
                            valueKey: 'label'
                        }
                    },
                    {
                        key: 'localidade',
                        label: 'mensagens.pessoas.tabela.localidade',
                        component: 'el-select',
                        value: '',
                        options: [],
                        rules: {
                            required: true,
                            message: this.$t(
                                'mensagens.comuns.campoObrigatorio'
                            ),
                            trigger: 'blur'
                        },
                        bind: {
                            placeholder: 'mensagens.pessoas.tabela.localidade',
                            valueKey: 'label'
                        }
                    },
                    {
                        key: 'id',
                        label: this.isAlvorada
                            ? 'BP Pessoa'
                            : 'mensagens.operacao.formularioPessoa.idPessoa',
                        component: 'el-input',
                        value: '',
                        bind: {
                            maxlength: 200,
                            placeholder: this.isAlvorada
                                ? 'BP Pessoa'
                                : 'mensagens.operacao.formularioPessoa.idPessoa'
                        }
                    }
                ]
            },

            formSave: []
        };
    },

    computed: {
        ...mapGetters(['usuarioLogado', 'isAlvorada']),
        locale() {
            return this.usuarioLogado.ambienteLogado !== ''
                ? this.usuarioLogado.ambienteLogado.toLowerCase()
                : 'br';
        },
        formulario() {
            const { base, ar, py, br } = this.form;
            const country = this.usuarioLogado.ambienteLogado;

            let formBase = base;
            switch (country) {
                case 'AR':
                    formBase[2].bind.placeholder = 'mensagens.pessoas.cuit';
                    formBase[2].label = this.$t('mensagens.pessoas.cuit');
                    return { form: [...formBase, ...ar] };

                case 'PY':
                    formBase[2].bind.placeholder = this.$t(
                        'mensagens.comuns.ruc'
                    );
                    formBase[2].label = this.$t('mensagens.pessoas.numeroRuc');
                    return { form: [...formBase, ...py] };

                default:
                    formBase[2].bind.placeholder =
                        'mensagens.pessoas.numeroCpfCnpj';
                    return { form: [...formBase, ...br] };
            }
        }
    },

    watch: {
        dadosRepresentante: {
            immediate: true,
            handler(person) {
                if (!this.editar) return;
                if (Object.keys(person).length === 0) return;

                const {
                    nomeRazaoSocial,
                    documentoDecrypt,
                    email,
                    idCliente,
                    telefono,
                    direccion,
                    localidadeNivelDois,
                    localidadeNivelUm,
                    localidadeNivelTres,
                    siglaOrigemAmbiente
                } = person;

                this.form.base[0].value = this.form.base[0].value =
                    this.paises.find(item => item.code === siglaOrigemAmbiente)
                        ?.label
                        ? this.paises.find(
                              item => item.code === siglaOrigemAmbiente
                          )?.label
                        : 'Brasil';
                this.form.base[1].value = nomeRazaoSocial;
                this.form.base[2].value =
                    siglaOrigemAmbiente === 'AR'
                        ? this.formatCuit(documentoDecrypt)
                        : documentoDecrypt;
                this.form.base[3].value = email;

                if (siglaOrigemAmbiente === 'AR') {
                    this.form[this.locale][0].value = telefono;
                    this.form[this.locale][1].value = localidadeNivelUm;
                    this.form[this.locale][2].value = localidadeNivelDois;
                    this.form[this.locale][3].value = localidadeNivelTres;
                    this.form[this.locale][4].value = idCliente;
                } else if (siglaOrigemAmbiente === 'PY') {
                    this.form[this.locale][0].value = telefono;
                    this.form[this.locale][1].value = direccion;
                    this.form[this.locale][2].value = localidadeNivelUm;
                    this.form[this.locale][3].value = localidadeNivelDois;
                    this.form[this.locale][4].value = idCliente;
                } else {
                    this.form[this.locale][0].value = idCliente;
                }

                if (siglaOrigemAmbiente !== 'BR') {
                    this.listarLocalidadeNivelDois(Number(localidadeNivelUm));
                    if (siglaOrigemAmbiente !== 'PY') {
                        this.listarLocalidadeNivelTres(
                            Number(localidadeNivelDois)
                        );
                    }
                }
            }
        },
        formulario: {
            deep: true,
            handler({ form }) {
                this.formSave = form;
            }
        },
        'usuarioLogado.ambienteLogado': {
            immediate: true,
            handler(ambiente) {
                this.form.base[3].rules[1].required = ambiente === 'AR';

                if (ambiente !== 'BR') {
                    this.listarLocalidadeNivelUm();
                }

                if (this.editar) return;
                this.form.base[0].value = this.paises.find(
                    item => item.code === ambiente
                )?.label
                    ? this.paises.find(item => item.code === ambiente)?.label
                    : 'Brasil';
            }
        }
    },
    methods: {
        ...mapActions(['setRepresentante', 'removeRepresentante']),

        updateMask(key, mask, value) {
            if (mask === undefined) return;

            this.inputMask[key] = this.masksDocuments(key, mask, value);
        },
        masksDocuments(key, mask, value) {
            if (key === 'documento') {
                switch (this.locale) {
                    case 'ar':
                        return '##-########-#';
                    case 'py':
                        return '########-#';
                    default:
                        return value.length <= 14
                            ? '###.###.###-##'
                            : '##.###.###/####-##';
                }
            } else if (key === 'telefone') {
                switch (this.locale) {
                    case 'ar':
                        return value.length <= 12
                            ? '## ####-####'
                            : '# ## ####-####';
                    case 'py':
                        return value.length <= 10
                            ? '## ### ###'
                            : '### ### ###';
                    default:
                        return '## ##### ####';
                }
            } else {
                return mask || '';
            }
        },

        permissaoAmbiente(ambiente) {
            return this.usuarioLogado.ambienteLogado === ambiente;
        },

        atualizarListaRepresentantes() {
            this.$emit('atualizarListaRepresentantes');
        },

        fechar() {
            this.form.base = this.form.base.map((item, index) => {
                if (index > 0) {
                    return { ...item, value: '' };
                } else {
                    return { ...item };
                }
            });

            this.form[this.locale] = this.form[this.locale].map(item => {
                return { ...item, value: '' };
            });

            this.$emit('fechar');
        },

        salvar(formName) {
            try {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        let params = {};

                        if (this.locale === 'py') {
                            const [
                                ,
                                nome,
                                documento,
                                email,
                                telefone,
                                endereco,
                                estado,
                                municipio,
                                idCliente
                            ] = this.formSave;

                            params = {
                                nomeRazaoSocial: nome.value,
                                documento: formatters.removerPontuacaoDocumento(
                                    documento?.value
                                ),
                                email: email.value,
                                telefono: telefone.value,
                                localidadeNivelUm: estado.value,
                                localidadeNivelDois: municipio.value,
                                idCliente: idCliente.value,
                                direccion: endereco.value,
                                tipoDocumento: 2
                            };
                        } else if (this.locale === 'ar') {
                            const [
                                ,
                                nome,
                                documento,
                                email,
                                telefone,
                                estado,
                                municipio,
                                localidade,
                                idCliente
                            ] = this.formSave;

                            params = {
                                nomeRazaoSocial: nome.value,
                                documento: formatters.removerPontuacaoDocumento(
                                    documento?.value
                                ),
                                email: email.value,
                                telefono: telefone.value,
                                localidadeNivelUm: estado.value,
                                localidadeNivelDois: municipio.value,
                                localidadeNivelTres: localidade.value,
                                idCliente: idCliente.value,
                                tipoDocumento: 3
                            };
                        } else {
                            const [, nome, documento, email, idCliente] =
                                this.formSave;
                            params = {
                                nomeRazaoSocial: nome?.value,
                                cpfCnpj: formatters.cpfCnpjFormatToNumeral(
                                    documento?.value
                                ),
                                email: email?.value,
                                idCliente:
                                    idCliente?.value ||
                                    this.formSave[this.formSave.length - 1]
                                        .value,
                                idTipoDocumento: 1
                            };
                        }

                        if (this.editar) {
                            this.editarRepresentante(params);
                        } else {
                            this.cadastrarRepresentante(params);
                        }
                    } else {
                        return false;
                    }
                });
            } catch (error) {
                console.log('salvar ~ error:', error);
            }
        },

        redirecionarTerritorio() {
            this.mostrarModalRedirecionamentoTerritorio = true;
        },

        async editarRepresentante(params) {
            try {
                if (this.locale === 'br') {
                    await RepresentanteService.editarRepresentante({
                        id: this.dadosRepresentante.id,
                        ...params
                    });
                } else if (this.locale === 'py') {
                    await RepresentanteService.editarRepresentantePy({
                        id: this.dadosRepresentante.id,
                        ...params
                    });
                } else {
                    await RepresentanteService.editarRepresentanteAr({
                        id: this.dadosRepresentante.id,
                        ...params
                    });
                }

                this.fechar();
                this.atualizarListaRepresentantes();

                this.$notify.success({
                    message: this.$t(
                        'mensagens.pessoas.pessoaEditadaComSucesso'
                    )
                });
            } catch (e) {
                console.error('Edição de pessoa', e.response.data);

                this.$notify.error({
                    message: e.response.data.message
                });
            }
        },

        formatCuit(cuit) {
            if (cuit.length !== 11) {
                this.$t('mensagens.pessoas.cuitErro');
            }

            return `${cuit.slice(0, 2)}-${cuit.slice(2, 10)}-${cuit.slice(10)}`;
        },

        async cadastrarRepresentante(params) {
            try {
                let response = null;
                if (this.locale === 'br') {
                    const { data } =
                        await RepresentanteService.cadastrarRepresentante(
                            params
                        );
                    response = data;
                } else if (this.locale === 'py') {
                    const { data } =
                        await RepresentanteService.cadastrarRepresentantePy(
                            params
                        );
                    response = data;
                } else {
                    const { data } =
                        await RepresentanteService.cadastrarRepresentanteAr(
                            params
                        );
                    response = data;
                }

                this.setRepresentante(response);

                this.fechar();
                this.atualizarListaRepresentantes();

                this.$notify.success({
                    message: this.$t(
                        'mensagens.pessoas.pessoaAdicionadaComSucesso'
                    )
                });

                this.redirecionarTerritorio();
            } catch (e) {
                console.error('Cadastro de Pessoa', e.response.data);

                this.$notify.error({
                    message: e.response.data.message
                });
            }
        },

        fecharModalAtalhoTerritorio() {
            this.removeRepresentante();
            this.mostrarModalRedirecionamentoTerritorio = false;
        },

        updateCity(key) {
            if (key !== 'estado' && key !== 'municipio') return;

            const indexEstado = this.form[this.locale].findIndex(
                item => item.key === 'estado'
            );
            const indexCidade = this.form[this.locale].findIndex(
                item => item.key === 'municipio'
            );
            const indexLocalidade = this.form[this.locale].findIndex(
                item => item.key === 'localidade'
            );

            if (indexCidade !== -1 && key === 'estado') {
                this.form[this.locale][indexCidade].value = '';
            }
            if (indexLocalidade !== -1) {
                this.form[this.locale][indexLocalidade].value = '';
            }

            let value = null;
            if (key === 'estado' && indexEstado !== -1) {
                value = this.form[this.locale][indexEstado].value;
            } else if (key === 'municipio' && indexCidade !== -1) {
                value = this.form[this.locale][indexCidade].value;
            }

            if (!value) return;

            if (key === 'estado') {
                this.listarLocalidadeNivelDois(value);
            } else if (key === 'municipio' && indexLocalidade !== -1) {
                this.listarLocalidadeNivelTres(value);
            }
        },

        async listarLocalidadeNivelUm() {
            try {
                const { data } =
                    await LocalidadeService.buscarLocalidadeNivelUm();

                const dataFormat = data
                    .map(item => {
                        return { label: item.nome, code: item.id };
                    })
                    .sort((a, b) => this.orderName(a, b));

                if (this.locale !== 'br') {
                    const index = this.form[this.locale].findIndex(
                        item => item.key === 'estado'
                    );
                    this.form[this.locale][index].options = dataFormat;
                }
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.pessoas.erroBuscarLocalidadeNivelUm'
                    )
                });
            }
        },

        async listarLocalidadeNivelDois(id) {
            try {
                const { data } =
                    await LocalidadeService.buscarLocalidadeNivelDois(id);
                const dataFormat = data
                    .map(item => {
                        return { label: item.nome, code: item.id };
                    })
                    .sort((a, b) => this.orderName(a, b));

                const index = this.form[this.locale].findIndex(
                    item => item.key === 'municipio'
                );
                this.form[this.locale][index].options = dataFormat;
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.pessoas.erroBuscarLocalidadeNivelDois'
                    )
                });
            }
        },

        async listarLocalidadeNivelTres(id) {
            try {
                const { data } =
                    await LocalidadeService.buscarLocalidadeNivelTres(id);
                const dataFormat = data.map(item => {
                    return { label: item.nome, code: item.id };
                });
                const index = this.form[this.locale].findIndex(
                    item => item.key === 'localidade'
                );
                this.form[this.locale][index].options = dataFormat.sort();
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.pessoas.erroBuscarLocalidadeNivelDois'
                    )
                });
            }
        },
        orderName(a, b) {
            const nameA = a.label.toUpperCase();
            const nameB = b.label.toUpperCase();
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        }
    }
};
</script>

<style lang="scss">
#modal-editar-cadastrar-representante {
    footer {
        display: flex;
        justify-content: space-between;
    }

    .invalido {
        color: var(--danger);
    }

    .espaco {
        display: flex;
    }

    .el-form-item .el-form-item__label {
        font-weight: normal !important;
    }
}
</style>
